
import { Sale } from "@/models/base";
import { SaleService } from "@/services/sale-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppSaleSearch from "./SaleSearch.vue";
import AppSaleBrowse from "./SaleSearchBrowse.vue";
import {UserConfigService, ViewService} from "@/services";
import {View} from "@/models/view";

export default Vue.extend({
	data() {
		return {
			browseModalOpen: false,
			generalSettings: UserConfigService.getGeneralSettings(),
			view: null as View | null,
		};
	},
	props: {
		label: {
			type: [Object as ()=>TranslateResult, String]
		},
		placeholder: {
			type: [Object as ()=>TranslateResult, String]
		},
		fancy: Boolean,
		multiple: {
			type: Boolean,
			default: false
		},
		value: {
			type: Object as () => Sale
		},
		disabled: Boolean,
		showRemoveButton: Boolean
	},
	methods: {
		openBrowseModal() {
			this.browseModalOpen = true;
		},
		async onBrowseItemsSelected(sales:Sale[]) {
			let r = [];
			for (const sale of sales) {
				let s = await SaleService.getSale(sale.ID);
				r.push(s);
			}
			this.browseModalOpen = false;
			this.$emit("batch", sales);
		},
		async onBrowseItemSelected(sale:Sale) {
			let s = await SaleService.getSale(sale.ID);
			this.browseModalOpen = false;
			this.$emit("input", s);
		}
	},
	async mounted(){
		if(this.generalSettings.DefaultBankSalesF3Browse>0){
			this.view = await ViewService.getView(this.generalSettings.DefaultBankSalesF3Browse);
		}
	},
	components: {
		AppSaleSearch,
		AppSaleBrowse
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
